import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AiGenerationComponent } from '../../ai-generation.component';

@Component({
    selector: 'app-ai-potrait-prompt',
    templateUrl: './ai-potrait-prompt.component.html',
    styleUrls: ['./ai-potrait-prompt.component.scss'],
    standalone: false
})
export class AIPotraitPromptComponent implements OnInit {

  constructor(
    private activeModal:NgbActiveModal,
    private modal:NgbModal
  ) { }
  isGenerating = false  
  isGenerated:boolean = false

  ngOnInit(): void {
  }
  
  generateImage(isGenerated?:boolean){
    if(!isGenerated){
    this.isGenerating = true
    setTimeout(() => {
      this.isGenerating = false
      this.isGenerated = true
    }, 8000);}
    else {
      this.modal.dismissAll()
      // this.activeModal.close()
      this.modal.open(AiGenerationComponent, {
        size:'md',
        centered:true,
        backdrop:'static'
      })
    }
  }

  closeModal(){
    this.activeModal.close()
  }
}

